import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import { useContextWithValidation } from '@adsk/alloy-react-context';

const StoreContext = createContext();

export const useStore = () =>
  useContextWithValidation(StoreContext, {
    hook: 'useStore',
    provider: 'StoreProvider',
  });

export const StoreProvider = ({ children, state, dispatch }) => (
  <StoreContext.Provider value={{ state, dispatch }}>
    {children}
  </StoreContext.Provider>
);

StoreProvider.propTypes = {
  children: PropTypes.node.isRequired,
  dispatch: PropTypes.func,
  state: PropTypes.object,
};
